import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as themes from '../../../constants/theme';
import withTheme from '../../withTheme/withTheme';

import './text-container.scss';

const TextContainer = (props) => {
    const { children, theme, center } = props;
    const containerClassName = classNames('text-container', {
        [`text-container--${theme}`]: true,
        'text-container--center': center,
    });

    return (
        <div className={containerClassName}>
            {children}
        </div>
    );
};

TextContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    theme: PropTypes.oneOf(Object.values(themes)),
    center: PropTypes.bool,
};

TextContainer.defaultProps = {
    children: null,
    theme: themes.PUBLIC,
    center: false,
};

export const ThemedTextContainer = withTheme(TextContainer);

export default TextContainer;
